import React from 'react';

import { LegalNotice } from 'components/legal-notice/LegalNotice';

export const LegalNoticePage: React.FC = () => {
    return <LegalNotice />;
};
